<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
    >
        <path
            d="M14.5 6C14.776 6 15 5.776 15 5.5V4.5C15 4.224 14.776 4 14.5 4H6V1L1 5L3.125 6.75"
            stroke="#8E8E93"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10 15V7L15 11L10 15Z"
            fill="#8E8E93"
            stroke="#8E8E93"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M1.5 10H12V12H1.5C1.224 12 1 11.776 1 11.5V10.5C1 10.224 1.224 10 1.5 10Z"
            fill="#8E8E93"
            stroke="#8E8E93"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
